export default __webpack_public_path__ + "static/media/web.37a5c06d.svg";